<div class="card animated fadeInLeftBig">
  <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
  <div class="card-body">
      <div *ngIf="embedConfig">
          <ngx-powerbi-component type="report" id="{{embedConfig.id}}" embedUrl="{{embedConfig.embedUrl}}"
              tokenType="AAD" accessToken="{{embedConfig.accessToken}}" on-embedded="onEmbedded($event)"
              [options]="options" style="border: 0px !important;">
          </ngx-powerbi-component>
      </div>
  </div>
</div>
